<template>
  <v-dialog v-model="show_dialog" @click:outside="closeDialog">
    <v-card>
      <v-container class="">
        <v-row class="mt-4">
          <v-col>
            <span class="mr-4" style="font-size: 20px">De:</span>
            <span>{{ selected_ci.created_by }}</span>
          </v-col>
        </v-row>
        <template v-if="!is_received">
          <v-row>
            <v-col>
              <span class="mr-4" style="font-size: 20px">Para:</span>
              <template v-for="(destination, index) in getDestinationArray()">
                <span :key="index">{{ destination }}</span>
              </template>
            </v-col>
          </v-row>
          <v-row v-if="to_departments">
            <v-col>
              <span class="mr-4" style="font-size: 20px">Lotação:</span>

              <span>{{ selected_ci.workstation_name }}</span>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col cols="12">
            <p class="mr-4" style="font-size: 20px">Menssagem:</p>
            <p v-html="selected_ci.message"></p>
          </v-col>
          <v-col cols="12">
            <v-container
              class="d-flex flex-column"
              style="width: 60%"
              v-if="selected_ci.requires_signature && !selected_ci.signed && !sended"
            >
              <v-btn
                color="green ligthen-1"
                style="font-size: 18px"
                class="white--text"
                large
                @click="sign"
                >Assinar</v-btn
              >
            </v-container>
            <v-container
              class="d-flex flex-column"
              style="width: 60%"
              v-if="selected_ci.requires_signature && selected_ci.signed && !sended"
            >
              <span
                class="mx-auto text-h5 white--text"
                style="background: #ff9a40; padding: 8px 40%; border-radius: 4px"
                >Assinado</span
              >
            </v-container>
          </v-col>
        </v-row>
        <v-row v-if="selected_ci.requires_signature && sended && selected_ci.signatures">
          <v-col>
            <span class="mr-4" style="font-size: 20px">Assinado por:</span>
            <template v-for="(sign, index) in getSignaturesArray()">
              <span :key="index">{{ sign }}</span>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ShowCi',
  props: ['selected_ci', 'show_dialog', 'closeDialog', 'sended'],
  data: function () {
    return {
      dialog: false,
      to_departments: false,
      is_received: false,
    }
  },
  watch: {
    show_dialog() {
      this.dialog = this.show_dialog
    },
    selected_ci() {
      if (this.selected_ci) {
        if (!this.selected_ci.departments) {
          this.is_received = true
        } else {
          if (this.selected_ci.departments.length > 0) {
            this.to_departments = true
          } else {
            this.to_departments = false
          }
        }
      }
    },
  },
  computed: {},
  methods: {
    ...mapActions('ci', ['ActionSignIC']),
    ...mapActions('ui', ['ActionSetLoading']),
    async sign() {
      this.ActionSetLoading(true)
      this.$swal({
        icon: 'success',
        title: 'Assinado',
        text: 'A CI foi assinada com sucesso!',
      })
      this.closeDialog()
      try {
        this.ActionSignIC(this.selected_ci.id)
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }

      this.ActionSetLoading(false)
    },
    getDestinationArray() {
      const destination_list = []
      if (this.selected_ci && !this.is_received) {
        this.selected_ci.employees.map((emp, index) => {
          destination_list.push(emp.name)
          if (index != this.selected_ci.employees.length - 1) {
            destination_list.push(', ')
          }
        })
        this.selected_ci.departments.map((dep, index) => {
          destination_list.push(dep.name)
          if (index != this.selected_ci.departments.length - 1) {
            destination_list.push(', ')
          }
        })
      }
      return destination_list
    },
    getSignaturesArray() {
      const signatures_list = []
      this.selected_ci.signatures.map((sign, index) => {
        signatures_list.push(sign.name)
        if (index != this.selected_ci.signatures.length - 1) {
          signatures_list.push(', ')
        }
      })
      return signatures_list
    },
  },
}
</script>
